<template>
  <section class="registration-promo">
    <div class="container">
      <div class="promo-wrapper">
        <!-- Левая часть -->
        <div class="promo-left">
          <h2>
            Регистрируйся сейчас и получи —<br /><span
              >5 бесплатных проверок</span
            >
            в первые 30 дней!
          </h2>
          <ul class="benefits-list">
            <li><img src="@/assets/images/icons/check.svg" /> Без оплаты</li>
            <li><img src="@/assets/images/icons/check.svg" /> Без карты</li>
            <li>
              <img src="@/assets/images/icons/check.svg" /> Без автосписаний
            </li>
          </ul>
        </div>

        <template v-if="currentView !== 'forgot'">
          <!-- Правая часть -->
          <div class="promo-right">
            <div class="form-box">
              <div class="tabs">
                <button
                  :class="{ active: activeTab === 'login' }"
                  class="tab"
                  @click="activeTab = 'login'"
                >
                  Вход
                </button>
                <button
                  :class="{ active: activeTab === 'register' }"
                  class="tab"
                  @click="activeTab = 'register'"
                >
                  Регистрация
                </button>

                <!-- <button class="tab active">Вход</button>
              <button class="tab">Регистрация</button> -->
              </div>
              <div v-if="registrationSuccess" class="success-message">
                ✅ Регистрация прошла успешно!
              </div>

              <form v-if="activeTab === 'register'" class="auth-form">
                <input
                  type="text"
                  placeholder="Фамилия и имя"
                  v-model="form.full_name"
                  required
                />
                <input
                  type="email"
                  placeholder="E-mail"
                  v-model="form.email"
                  required
                />
                <div class="error alert" role="alert" v-if="emailError">
                  {{ emailError }}
                </div>
                <div class="password-field">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Пароль"
                    v-model="form.password"
                    @input="checkPassword"
                    required
                  />
                  <button
                    type="button"
                    class="eye-btn"
                    @click="toggleShowPassword"
                    aria-label="Показать/скрыть пароль"
                  >
                    <img
                      src="@/assets/images/icons/eye-open.svg"
                      class="eye_open"
                      alt="Eye open"
                      v-if="!showPassword"
                    />
                    <img
                      src="@/assets/images/icons/eye-slashed.svg"
                      class="eye_slashed"
                      alt="Eye slashed"
                      v-else
                    />
                  </button>
                </div>
                <div class="error alert" role="alert" v-if="passwordError">
                  {{ passwordError }}
                </div>
                <div class="password-field">
                  <input
                    :type="showRepeatPassword ? 'text' : 'password'"
                    placeholder="Повторить пароль"
                    v-model="repeatPassword"
                    @input="checkRepeatPassword"
                    required
                  />
                  <button
                    type="button"
                    class="eye-btn"
                    @click="toggleShowRepeatPassword"
                    aria-label="Показать/скрыть пароль"
                  >
                    <img
                      src="@/assets/images/icons/eye-open.svg"
                      class="eye_open"
                      alt="Eye open"
                      v-if="!showRepeatPassword"
                    />
                    <img
                      src="@/assets/images/icons/eye-slashed.svg"
                      class="eye_slashed"
                      alt="Eye slashed"
                      v-else
                    />
                  </button>
                </div>
                <div class="error alert" role="alert" v-if="repeatError">
                  {{ repeatError }}
                </div>
                <div class="agreement">
                  <input
                    type="checkbox"
                    id="agree"
                    v-model="form.acceptTerms"
                  />
                  <label for="agree"
                    >Я принимаю условия использования и
                    <a href="/terms_new.pdf" target="_blank" rel="noopener"
                      >политику конфиденциальности</a
                    >
                  </label>
                </div>
                <button
                  class="submit-btn"
                  :disabled="!isRegisterFormValid"
                  type="button"
                  @click="register()"
                >
                  <template v-if="!isLoading"> Зарегистрироваться </template>
                  <div v-else class="loader mx-auto my-0"></div>
                </button>
              </form>
              <form v-else class="auth-form">
                <input type="email" placeholder="E-mail" v-model="user.email" />
                <input
                  type="password"
                  placeholder="Пароль"
                  v-model="user.password"
                />
                <div class="alert" role="alert" v-if="authError">
                  Неверный логин или пароль
                </div>

                <button
                  type="button"
                  class="btn btn-link"
                  @click="switchView('forgot')"
                >
                  Забыли пароль?
                </button>
                <button class="submit-btn" type="button" @click="login()">
                  <template v-if="!isLoading"> Войти </template>
                  <div v-else class="loader mx-auto my-0"></div>
                </button>
              </form>
            </div>
          </div>
        </template>
        <!-- Восстановление пароля -->
        <form v-else-if="currentView === 'forgot'" class="forgot-form">
          <input
            type="email"
            placeholder="Введите ваш E-mail"
            v-model="email"
          />
          <div class="success-message" v-if="forgotSuccess">
            ✅ Письмо с инструкциями отправлено!
          </div>
          <div class="alert" role="alert" v-if="error">
            {{ error }}
          </div>

          <button type="button" class="submit-btn" @click="resetPassword()">
            Отправить инструкции
          </button>
          <button
            type="button"
            class="btn btn-link mt-2"
            @click="switchView('auth')"
          >
            Назад ко входу
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AuthService from "../services/auth";

const activeTab = ref("register");

const isLoading = ref(false);
const store = useStore();
const registrationSuccess = ref(false);

const user = ref({
  email: "",
  password: "",
  rememberMe: false,
});
const router = useRouter();

const username = ref("");
const error = ref(null);
const email = ref("");
const password = ref("");
const isRegisetred = ref("");
const form = ref({
  full_name: "",
  email: "",
  password: "",
  acceptTerms: "",
});

const authError = ref(false);
const isFormValid = computed(() => {
  return user.value.email && user.value.password;
});
const isRegisterFormValid = computed(() => {
  return (
    form.value.full_name &&
    form.value.email &&
    form.value.password &&
    form.value.password.length >= 8 &&
    form.value.acceptTerms &&
    repeatPassword.value &&
    form.value.password === repeatPassword.value &&
    !repeatError.value
  );
});
const currentView = ref("auth"); // auth, register, forgot
const switchView = (view) => {
  currentView.value = view;
  error.value = null;
  authError.value = false;
  registrationSuccess.value = false;
};

const forgotEmail = ref("");
const forgotSuccess = ref(false);
const message = ref(null);

const repeatPassword = ref("");
const showPassword = ref(false);
const showRepeatPassword = ref(false);
const repeatError = ref(null);
const emailError = ref(null);
const passwordError = ref(null);

const toggleShowRepeatPassword = () => {
  showRepeatPassword.value = !showRepeatPassword.value;
};

const toggleShowPassword = () => {
  showPassword.value = !showPassword.value;
};

const checkRepeatPassword = () => {
  if (form.value.password !== repeatPassword.value) {
    repeatError.value = "Пароли не совпадают";
  } else {
    repeatError.value = null;
  }
};

const resetPassword = () => {
  const data = {
    email: email.value,
  };

  AuthService.resetPassword(data)
    .then((response) => {
      message.value =
        "Письмо со ссылкой на восстановление аккаунта отправлено Вам на почту";
      return Promise.resolve(response);
    })
    .catch((error) => {
      console.log(error);
      if (
        error.response.data.email[0] ===
        "Пользователь with this Электронная почта already exists."
      ) {
        alert("Пользватель с такой почтой уже зарегистрирован");
      }
      return Promise.reject(error);
    });
};

const checkPassword = () => {
  passwordError.value = null;

  const minLength = /.{8,}/; // Проверка на минимальную длину (8+ символов)
  const hasDigit = /[0-9]/; // Проверка на наличие хотя бы одной цифры
  const hasSpecialChar = /[!@#$%^&*()_+<>?-]/; // Проверка на наличие специального символа

  if (!minLength.test(form.value.password)) {
    passwordError.value = "Пароль должен содержать минимум 8 символов.";
  } else if (!hasDigit.test(form.value.password)) {
    passwordError.value = "Пароль должен содержать хотя бы одну цифру.";
  } else if (!hasSpecialChar.test(form.value.password)) {
    passwordError.value =
      "Пароль должен содержать хотя бы один специальный символ.";
  } else {
    passwordError.value = null;
  }

  if (repeatPassword.value) checkRepeatPassword();
};
const login = async () => {
  isLoading.value = true;
  if (!isFormValid.value) {
    alert("Пожалуйста, заполните все поля и примите условия.");
    return;
  }
  try {
    await store.dispatch("auth/login", user.value);
    await store.dispatch("user/me");
    isLoading.value = false;
    router.push("/profile/info");
  } catch (error) {
    console.log("error", error);
    isLoading.value = false;
    authError.value = true;
  }
};
const register = () => {
  isLoading.value = true;
  emailError.value = null;
  passwordError.value = null;
  if (!form.value.acceptTerms) {
    alert("Пожалуйста, примите условия.");
    return;
  }
  const data = {
    full_name: form.value.full_name,
    email: form.value.email,
    password: form.value.password,
  };
  AuthService.registration(data)
    .then((response) => {
      isRegisetred.value = true;
      isLoading.value = false;
      registrationSuccess.value = true;

      // router.push("/profile/info");
      return Promise.resolve(response);
    })
    .catch((err) => {
      console.log("error", err);
      isLoading.value = false;
      if (err.response && err.response.data.email) {
        if (
          err.response.data.email[0] ===
          "Пользователь with this Электронная почта already exists."
        ) {
          emailError.value = "Пользватель с такой почтой уже зарегистрирован";
          return;
        }
      }
      if (err.response && err.response.data.password) {
        if (
          err.response.data.password[0] ===
          "The password is too similar to the Электронная почта."
        ) {
          passwordError.value = "Пароль слишком похож на электронную почту";
          return;
        }
      }
      // error.value = "Введите верные данные";
      // return Promise.reject(err);
    });
};
</script>

<style scoped lang="scss">
.alert {
  color: red;
}
.success-message {
  background-color: #e6f7e6;
  color: #1e4620;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-weight: 600;
}

.registration-promo {
  background: linear-gradient(137deg, #00c782 0%, #016542 100%);
  padding: 60px 0 0 0;
  color: white;
  min-height: calc(100vh - 86px);
  display: flex;

  .container {
    max-width: 1200px;
    margin: auto;
    padding: 0 20px;
  }

  .promo-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    margin: auto;
  }

  .promo-left {
    flex: 1 1 50%;

    h2 {
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 24px;

      span {
        font-size: 36px;
        display: block;
        margin: 10px 0;
      }
    }

    .benefits-list {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        font-size: 18px;
        margin-bottom: 10px;

        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }
    }
  }

  .promo-right {
    flex: 1 1 45%;
    display: flex;
    justify-content: center;

    .form-box {
      background: white;
      padding: 32px;
      border-radius: 30px;
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
      color: #333;
      width: 100%;
      max-width: 400px;
      box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);

      .tabs {
        display: flex;
        margin-bottom: 24px;

        .tab {
          flex: 1;
          background: rgba(243, 243, 243, 1);
          padding: 12px;
          border: none;
          font-weight: 600;
          cursor: pointer;
          &:first-child {
            border-radius: 10px 0 0 10px;
          }
          &:last-child {
            border-radius: 0 10px 10px 0;
          }
          &.active {
            background: rgba(0, 199, 130, 1);
            color: #fff;
          }
        }
      }

      form {
        display: flex;
        flex-direction: column;

        input[type="text"],
        input[type="email"],
        input[type="password"] {
          padding: 12px;
          margin-bottom: 16px;
          border: 1px solid #ccc;
          border-radius: 8px;
          font-size: 16px;
        }

        .agreement {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          margin-bottom: 16px;

          input[type="checkbox"] {
            margin: 0;
            flex-shrink: 0;
          }

          label {
            margin-left: 8px;
            line-height: 1.4;
            cursor: pointer;

            a {
              text-decoration: none;
            }
          }
        }

        .submit-btn {
          background: linear-gradient(90deg, #00c782 0%, #12986a 100%);
          color: white;
          border: none;
          padding: 12px;
          border-radius: 100px;
          font-size: 16px;
          cursor: pointer;
        }

        .password-field {
          position: relative;

          input {
            width: 100%;
          }
        }

        .eye-btn {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 12px;

          margin-top: 16px;

          height: 24px;
          width: 24px;

          background: transparent;
          border: none;
          padding: 0;
          cursor: pointer;

          display: flex;
          justify-content: center;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
  .forgot-form {
    background: white;
    padding: 32px;
    border-radius: 30px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    color: #333;
    width: 100%;
    max-width: 400px;
    box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
    display: flex;
    flex-direction: column;

    input[type="text"],
    input[type="email"],
    input[type="password"] {
      padding: 12px;
      margin-bottom: 16px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 16px;
    }

    .submit-btn {
      background: linear-gradient(90deg, #00c782 0%, #12986a 100%);
      color: white;
      border: none;
      padding: 12px;
      border-radius: 100px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
